import React, { useCallback, useEffect, useRef, useState } from 'react'
import '../css/Product.css'
import { plusComma } from '../js/script'

const MultiRangeSlider = ({
  min,
  max,
  onChange,
  reset,
  setReset,
  setMaxValue,
  setMinValue,
  filterMin,
  filterMax,
  maxValInputRef,
  minValInputRef,
}: any) => {
  const [minVal, setMinVal] = useState(0)
  const [maxVal, setMaxVal] = useState(10000000)
  const minValRef = useRef(0)
  const maxValRef = useRef(10000000)
  const range = useRef<any>(null)

  // Convert to percentage
  const getPercent = useCallback((value: any) => Math.round(((value - minVal) / (max - min)) * 100), [min, max])

  useEffect(() => {
    setMinVal(filterMin)
    setMaxVal(filterMax)
    minValRef.current = filterMin
    maxValRef.current = filterMax
  }, [])

  useEffect(() => {
    setMaxValue(maxVal)
    setMinValue(minVal)
  }, [minVal, maxVal])

  // Set width of the range to decrease from the left side
  useEffect(() => {
    const minPercent = getPercent(minVal)
    const maxPercent = getPercent(maxValRef.current)

    if (range.current) {
      range.current.style.left = `${minPercent}%`
      range.current.style.width = `${maxPercent - minPercent}%`
    }
  }, [minVal, getPercent])

  useEffect(() => {
    if (reset) {
      setMinVal(min)
      setMaxVal(max)
      minValRef.current = min
      maxValRef.current = max
      setReset(false)
    }
  }, [reset, min, max, setReset])

  // Set width of the range to decrease from the right side
  useEffect(() => {
    const minPercent = getPercent(minValRef.current)
    const maxPercent = getPercent(maxVal)

    if (range.current) {
      range.current.style.width = `${maxPercent - minPercent}%`
    }
  }, [maxVal, getPercent])

  // Get min and max values when their state changes
  useEffect(() => {
    //@ts-ignore
    onChange({ min: minVal, max: maxVal })
  }, [minVal, maxVal, onChange])

  useEffect(() => {
    if (minVal > 9999998) {
      setMinVal(9995000)
    }
    if (maxVal > 10000000) {
      setMaxVal(10000000)
    }
  }, [minVal, maxVal])

  const handleMinFocus = () => {
    minValInputRef.current.classList.add('on')
  }
  // const handleMinBlur = () => {
  //   minValInputRef.current.classList.remove('on');
  // }
  const handleMaxFocus = () => {
    // setMaxVal(0);
    maxValInputRef.current.classList.add('on')
  }
  // const handleMaxBlur = () => {
  //   maxValInputRef.current.classList.remove('on');
  // }

  return (
    <div className='filter_slider'>
      <div className='container'>
        <div className='val_box'>
          <div className='min_val_num'>0</div>
          <div className='max_val_num'>1,000,0000 +</div>
        </div>
        <div className='range_box'>
          <input
            type='range'
            min={min}
            max={max}
            step={5000}
            value={minVal}
            onChange={(event) => {
              const value = Math.min(Number(event.target.value), maxVal - 1)
              setMinVal(value)
              minValRef.current = value
              if (value > 0) {
                minValInputRef.current.classList.add('on')
              } else {
                minValInputRef.current.classList.remove('on')
              }
            }}
            className='thumb thumb--left'
            // style={{ zIndex: minVal > max - 100 && '5' }}
          />
          <input
            type='range'
            min={min}
            max={max}
            step={5000}
            value={maxVal}
            onChange={(event) => {
              const value = Math.max(Number(event.target.value), minVal + 1)
              setMaxVal(value)
              maxValRef.current = value
              if (value < 10000000) {
                maxValInputRef.current.classList.add('on')
              } else {
                maxValInputRef.current.classList.remove('on')
              }
            }}
            className='thumb thumb--right'
          />
          <div className='slider__track' />
          <div ref={range} className='slider__range' />
        </div>

        <div className='slider'>
          <div className='slider__left-value' ref={minValInputRef}>
            <input
              type='text'
              value={plusComma(minVal)}
              onFocus={handleMinFocus}
              // onBlur={handleMinBlur}
              onChange={(e: any) => {
                const commaMinus = e.target.value.replaceAll(',', '')

                if (Number(commaMinus) < max) {
                  setMinVal(Number(commaMinus))
                } else {
                  setMinVal(max)
                }
              }}
            />
          </div>
          <div className='slider_icon'>~</div>
          <div className='slider__right-value' ref={maxValInputRef}>
            <input
              type='text'
              value={plusComma(maxVal)}
              onFocus={handleMaxFocus}
              // onBlur={handleMaxBlur}
              onChange={(e: any) => {
                const commaMinus = e.target.value.replaceAll(',', '')
                if (Number(commaMinus) < max) {
                  setMaxVal(Number(commaMinus))
                } else {
                  setMaxVal(max)
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

// MultiRangeSlider.propTypes = {
//   min: PropTypes.number.isRequired,
//   max: PropTypes.number.isRequired,
//   onChange: PropTypes.func.isRequired,
// };

export default MultiRangeSlider
